import { render } from "./STDSDC02C08UpdateBopAccount.vue?vue&type=template&id=fad71f86&scoped=true"
import script from "./STDSDC02C08UpdateBopAccount.vue?vue&type=script&lang=js"
export * from "./STDSDC02C08UpdateBopAccount.vue?vue&type=script&lang=js"

import "./STDSDC02C08UpdateBopAccount.vue?vue&type=style&index=0&id=fad71f86&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad71f86"]])

export default __exports__